import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import InputCheckBox from 'components/input/InputCheckBox';
import { useLocale } from '../../../components/special/LanguageProvider';
import { apiPostCall } from '../../../components/special/apiCall';
import { useToasts } from 'react-toast-notifications';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

const SettingYesNo = ({ definition }) => {   
    const [settingValue, setSettingValue] = useState(JSON.parse(definition.value));
    const { t } = useLocale();
    const [oldValue, setOldValue] = useState(definition.value);        
    const { addToast } = useToasts();

    const updateSetting = (jsonValue) =>{
        apiPostCall(BASE_URL + '/admin/setting/save', {...definition, value : jsonValue}).then(res => {                      
            setOldValue(jsonValue)            
            if (res && res.error){
                addToast(res.error.message, { appearance: 'error', autoDismiss : false })
            }
            else{                
                addToast(t('Breyting fyrir "') + t(definition.name) +t('" vistuð.'), { appearance: 'success' , autoDismiss : true })
            }            
        });        
    }

    const onUpdateValue = (value) => {
        let jsonValue = JSON.stringify(value);                
        setSettingValue(value);        
        if (jsonValue.localeCompare(oldValue) !== 0){            
            updateSetting(jsonValue);
        }
    }

    return (     
        <div className="table-wrap form">
        <table className="table">
            <colgroup>
                <col/>                
                <col />
            </colgroup>
        <thead>
        </thead>
        <tbody>                  
            <tr>
                <td className="no-border"><div className="form">{t(definition.name)}</div></td>                       
                <td className="no-border">  <InputCheckBox value={settingValue} onChange={(value) => onUpdateValue(value)} /></td>
            </tr>
        </tbody>
        </table>
        </div>          
        
        
      );
};


export default SettingYesNo;
